<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '../utils';
    import { Textarea } from '@/shared/ui/Textarea';

    const props = defineProps<{
        class?: HTMLAttributes['class'];
    }>();
</script>

<template>
    <Textarea
        data-slot="input-group-control"
        :class="cn('flex-1 resize-none rounded-none border-0 bg-transparent p-0 shadow-none focus-visible:ring-0 dark:bg-transparent', props.class)"
    />
</template>
